<wdx-icon [icon]="icon" [class]="fileType" [scale]="1"></wdx-icon>
